import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebAppShellRoutingModule } from './web-app-shell-routing.module';
import { ShellComponent } from './shell.component';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { HotkeyModule } from 'angular2-hotkeys';

@NgModule({
	imports: [CommonModule, HotkeyModule, WebAppShellRoutingModule, ShellComponent],
	exports: [ShellComponent],
})
export class WebAppShellModule {
	constructor(library: FaIconLibrary) {
		library.addIconPacks(fas, far);
	}
}
